import SectionHeading from '@/pages/home/components/SectionHeading';
import { overviewStats, overviewNotes } from '@/mocks/cinemaData';

export default function OverviewSection() {
  return (
    <section id="overview" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="站点概览"
          title="这一页能帮你解决什么"
          desc="把「该用哪种方式打开」这个问题拆开讲清楚：先分清手机版、电脑版、网页版与 APP 的定位，再给出浏览器观看与在线看的具体做法，最后用分类导览与常见问题收尾。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
          {overviewNotes.map((note) => (
            <article key={note.title} className="rounded-lg border border-background-200 bg-background-100 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-900">
                <i className={`${note.icon} text-xl`} aria-hidden="true" />
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{note.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{note.desc}</p>
            </article>
          ))}
        </div>

        <dl className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {overviewStats.map((stat) => (
            <div key={stat.label} className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <dt className="text-xs text-foreground-500">{stat.label}</dt>
              <dd className="mt-2 font-heading text-2xl font-semibold text-primary-600 md:text-3xl">{stat.value}</dd>
              <dd className="mt-1 text-xs text-foreground-500">{stat.desc}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}